import React, { useState } from "react";
import { Card, Button, UncontrolledCollapse } from "reactstrap";
import "../CarLoanCalculator/NewCarLoan.scss";

function PetrolFAQs({ bgClorClass }) {
  const [open, setOpen] = useState();
  const [open1, setOpen1] = useState();
  const [open2, setOpen2] = useState();
  const [open3, setOpen3] = useState();
  const [open4, setOpen4] = useState();
  const [open5, setOpen5] = useState();

  return (
    <section className={`FAQs section-padding ${bgClorClass}`}>
      <div className="container pb-3">
        <div
          className="border rounded d-flex flex-wrap align-items-center justify-content-center bg-lightgrey mb-4"
          style={{ minHeight: 200 }}
        >
          <img
            src="/images/auction-sheet-banners.png"
            style={{ height: "100%", width: "100%" }}
          ></img>
        </div>
        <h2 className="mb-4 text-center text-primary">
          Frequently Asked Questions
        </h2>
        <div className="row">
          <div className="col-sm-6">
            <Button
              className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between"
              color=""
              id="toggler1"
              onClick={() => setOpen(!open)}
            >
              <div className="text-left">
                <h5 className="mb-0 text-primary">
                  Who sets the Petroleum prices in Pakistan?
                </h5>
              </div>
              {open ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  The Oil and Gas Regulatory Authority (OGRA) sets petroleum
                  price changes on 15 days basis to the Federal Government. The
                  Government of Pakistan sets the petroleum prices.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
          <div className="col-sm-6">
            <Button
              className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between"
              color=""
              id="toggler2"
              onClick={() => setOpen1(!open1)}
            >
              <div className="text-left">
                <h5 className="mb-0 text-primary">
                  What RON petrol does Pakistan refine?
                </h5>
              </div>
              {open1 ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open1 ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  The RON stands for Research Octane Number which ranges from
                  95-97 currently for petrol refinement in Pakistan.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
          <div className="col-sm-6">
            <Button
              className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between"
              color=""
              id="toggler3"
              onClick={() => setOpen2(!open2)}
            >
              <div className="text-left">
                <h5 className="mb-0 text-primary">
                  Which Petrol is best for Cars?
                </h5>
              </div>
              {open2 ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open2 ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  Normally petrol with the RON 95 plus is best for smaller
                  engine cars under 1000cc, while for the cars with bigger
                  engines, High-Octane petrol price is always recommended.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
          <div className="col-sm-6">
            <Button
              className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between"
              color=""
              id="toggler4"
              onClick={() => setOpen3(!open3)}
            >
              <div className="text-left">
                <h5 className="mb-0 text-primary">
                  Which Petrol is best for Bikes?
                </h5>
              </div>
              {open3 ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open3 ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  The Petrol with 87 plus RON is good for the 70cc to 125cc
                  bikes. Although the higher engine Capacity of bikes requires
                  high-Octane petrol to provide best performance.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
          <div className="col-sm-6">
            <Button
              className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between"
              color=""
              id="toggler5"
              onClick={() => setOpen4(!open4)}
            >
              <div className="text-left">
                <h5 className="mb-0 text-primary">
                  What factors influence petrol prices in Pakistan?
                </h5>
              </div>
              {open4 ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open4 ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  Petrol prices in Pakistan are influenced by global crude oil
                  prices, exchange rates, taxes, refining and transportation
                  costs, and profit margins for oil marketing companies and
                  dealers. These factors combined determine the final retail
                  price of petrol in the country.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
          <div className="col-sm-6">
            <Button
              className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between"
              color=""
              id="toggler5"
              onClick={() => setOpen5(!open5)}
            >
              <div className="text-left">
                <h5 className="mb-0 text-primary">
                  How often do petrol prices change in Pakistan?
                </h5>
              </div>
              {open5 ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open5 ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  Petrol prices in Pakistan are typically adjusted monthly by
                  the OGRA, considering global oil prices and other factors.
                  Occasionally, mid-month adjustments may occur due to
                  significant market fluctuations or unforeseen events.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
export default PetrolFAQs;
